import FetchAPI from "../../helpers/FetchAPI";
import {TypeMethodContsantEnum} from "../../helpers/constant/MethodAPIConstant";

class WhDocumentService extends FetchAPI {
    public async list(data) {
        const result = await this.request(
            "wh/document/index",
            data,
            TypeMethodContsantEnum.GET
        );
        return result;
    }

    public async all() {
        const result = await this.request(
            "wh/document/all",
            {},
            TypeMethodContsantEnum.GET
        );
        return result;
    }

    public async find(id) {
        const result = await this.request(
            `wh/document/find/${id}`,
            {},
            TypeMethodContsantEnum.GET
        );
        return result;
    }

    public async store(data) {
        const result = await this.request(
            "wh/document/store",
            data,
            TypeMethodContsantEnum.POST
        );
        return result;
    }

    public async update(data) {
        const result = await this.request(
            "wh/document/update",
            data,
            TypeMethodContsantEnum.POST
        );
        return result;
    }

    public async getBase64(id) {
        const result = await this.request(
            `wh/document/getFile/${id}`,
            {},
            TypeMethodContsantEnum.GET
        );
        return result;
    }
}

export default WhDocumentService;
